import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import SurfaceTragusPiercingImage from '../../Assets/Piercing Services/surface tragus piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function SurfaceTragusPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Surface Tragus Piercing UAE | 350 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Surface Tragus Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Surface Tragus Piercing 350 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={SurfaceTragusPiercingImage} alt="Surface Tragus Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Surface Tragus Piercing</h3>

          <p>
            Stand out with a bold and contemporary look through our professional surface tragus piercing services in the UAE, available at an affordable price of 350 AED. Surface tragus piercing is a unique and modern style that sits on the surface of the skin over the tragus area, rather than passing through the cartilage like a traditional tragus piercing. This distinctive placement creates a striking visual effect, making it an ideal choice for individuals who want to experiment with unconventional and fashion-forward piercing styles. Whether you prefer sleek surface bars or subtle decorative jewelry, our expert specialists ensure precise placement for a clean, symmetrical, and eye-catching result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each surface tragus piercing with exceptional precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Surface piercings require advanced expertise due to their placement, and our experienced specialists are trained to handle the procedure carefully while minimizing discomfort and ensuring proper alignment.
          </p>

          <p>
            Surface tragus piercing is perfect for individuals who want a unique and edgy ear design that stands out from traditional piercings. Its surface-level placement gives it a bold and distinctive appearance, making it a great addition to a curated ear look. It pairs well with other ear piercings such as helix, conch, lobe, or standard tragus, allowing you to create a layered and personalized style. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your aesthetic and comfort.
          </p>

          <p>
            The procedure is typically completed within a short time, making it convenient for clients with busy schedules. Our team uses advanced techniques designed to reduce pain and promote efficient healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic surface jewelry that is safe for sensitive skin, helping to prevent irritation and supporting a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that surface piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs
          </p>

          <p>
            Aftercare is especially important for surface tragus piercings, and we provide detailed instructions to help you maintain proper care during the healing process. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. Following proper aftercare helps ensure better healing and long-lasting results.
          </p>

          <p>
            Our surface tragus piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted surface tragus piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and unique style effortlessly. Book your surface tragus piercing appointment today and redefine your ear aesthetics with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Surface Tragus Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SurfaceTragusPiercing;